import { Api } from 'utils';

class JourneyService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/journeys/get',params),
		create: async (params?: any) => Api.createResponse('admin/journeys/create',params),
		update: async (params?: any) => Api.createResponse('admin/journeys/update',params),
		delete: async (params?: any) => Api.createResponse('admin/journeys/delete',params),
	}

}

export default JourneyService;